import { Component } from '@angular/core';

/**
 * Global floating entry point into the warehouse assistant (see AssistantComponent).
 * Mounted once in the app shell so it is reachable from every page, not just
 * /warehousing/assistant — the underlying question/answer logic is unchanged, this is
 * only a launcher + popover around it.
 */
@Component({
    selector: 'app-assistant-launcher',
    templateUrl: './assistant-launcher.component.html',
    styleUrls: ['./assistant-launcher.component.scss'],
    standalone: false
})
export class AssistantLauncherComponent {
  open: boolean = false;

  toggle(): void {
    this.open = !this.open;
  }

  close(): void {
    this.open = false;
  }
}
